const participants = {
	title: "Students",
	stitle: "Student",
	new_participant: "New Student",
	edit_participant: "Edit Student: {name}",
	view_participant: "View Student: {name}",
	list_title: "List of Students",
	list_subtitle: "Manage Student",
	create_title: "Create New Student",
	update_title: "Update Student",
	address_title: "Address",
	details_title: "Student Details",
	id: "ID",
	pid: "PID",
	company_id: "Company",
	name: "Name",
	first_name: "First Name",
	middle_name: "Middle Name",
	last_name: "Last Name",
	email: "Email",
	mobile: "Mobile",
	birthday: "Birthday",
	date_of_birth: "Date of Birth",
	street: "Street",
	city: "City",
	state: "State",
	zip: "Zip Code",
	country: "Country",
	employeed_from: "Employeed From",
	comments: "Notes",
	created_by: "Created By",
	employees: "Employees",
	select_employees: "Select employees",
	type: "Type",
	merge: "Merge",
	verify_image: "Verify Image",
	not_verified: "Not Verified",
	merge_title: "Merge Participants",
	merge_sub: "Choose which participant data will be merged to",
	no_participant_selected: "Select a participant",
	merge_success: "Participants successfully merged",
	merge_failed: "Failed to merge participants",
	merge_confirm: "Participant and all their data will be merged into one. This action is not reversible! Would you like to proceed?",
	sync: "Sync",
	unique_id: "ID",
	documents: "Internal documents",
	add_documents: "Add Documents",
	upload_documents: "Upload Documents",
	select_documents: "Select Documents",
	student_group_id: "Student Group",
	certreguser_exist_confirm: "User of certreg already exists, do you want to add it as participant? <br/><br/> Name: {name} <br/> Email: {email} <br/> Mobile: {mobile}",
	update_document: "Update Document",
	students_documents: "Student's Documents",
	cannot_delete_has_enrolment_attendee: "Student is currently enrolled to or participating a course. They must be unenrolled/completed the course first in order to continue deleting this student.",
	age_below_18: "Personer under 18 år kan ikke utføre arbeid som medfører fare for liv eller helse. Forskrift om administrative ordninger §12-6 Selv om personen har fått og bestått opplæring som beskrevet under, kan ikke personer under 18 år, settes til selvstendig arbeid som kan medføre fare for live eller helse. Denne type arbeid kan bare gjennomføres som del av yrkesrettet opplærings, iht. unntak fra arbeidsforbud, Forskrift om organisering og ledelse §12-7",
	merge_to_existing: "Merge to existing student",
	merge_existing_participant: "Existing Student",
	merge_new_participant: "New Student",
	pid_exists_confirm: "The student with this PID is already registered in XL3. Would you like to get the data?",
	show_deleted_documents: "Trash can",
	show_documents: "Back",
	deleted_documents: "(Deleted documents)",
	internal_notes: "Internal notes",
	in_add_note: "Add note",
	in_new_title: "New Note",
	in_update_title: "Edit Note",
	in_note: "Note",
	employee_number: "Employee Number",
};
export default participants;